import { Injectable, OnDestroy } from '@angular/core';
import { AbstractCRUDService } from '@campaign-portal/components-library';
import { EntityField, InputComplexType, InputType } from '@campaign-portal/namespace/common/entityField';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class RatesFieldsService implements AbstractCRUDService, OnDestroy {

	readonly currencyName: EntityField = {
		id: 0,
		name: 'rates.currency_name',
		variable: 'currencyName',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly startDate: EntityField = {
		id: 1,
		name: 'rates.start_date',
		variable: 'startDate',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.DATE_RANGE
	};
	readonly rate: EntityField = {
		id: 2,
		name: 'rates.rate_to_sys',
		variable: 'rate',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
		
	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly headers: EntityField[] = [
		this.currencyName,
		this.startDate,
		this.rate
	];
		
	constructor() {
	}
		
	ngOnDestroy(): void {
		this.loading$.complete();
	}
		
	read(): Observable<ReadResponse<EntityField[]>> {
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});
		
	}
		
	create(): Observable<void> {
		return of();
	}
		
	update(): Observable<void> {
		return of();
	}
		
	delete(): Observable<void> {
		return of();
	}
}
